import React from 'react';
import './DashboardTablePage.css';
import Sidebar from '../../components/sidebar/Sidebar';
import DashboardServicesForAdmin from "../Services/DashboardServicesForAdmin";

const AddNewPermitDocPage = () => {
    return (
        <div className={"dashboard-page"}>
            <div className="dashboard-bggg">
                <div className="dashboard-flex-containerr">
                    <Sidebar />
                    <DashboardServicesForAdmin />
                </div>
            </div>
        </div>
    );
};

export default AddNewPermitDocPage;
